import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CoreGroups } from '@fc-vehicles/components/vehicle-group-colors/core.groups';

@Component({
  selector: 'fc-vehicle-group-colors',
  template: `
    <div class="group-container" [class.active]="active">
      <div
        class="main-groups"
        (mouseenter)="tooltipVisible = true"
        (mouseleave)="tooltipVisible = false"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
      >
        @for (group of groups | slice: 0 : 3; track $index; let i = $index) {
          <div
            class="group-item  {{ form }}"
            [ngClass]="{ last: i === 2 && groups?.length > 3 }"
            [style.background-color]="group?.color"
          ></div>
        }
        @if (groups?.length > 3) {
          <div class="quantity">+{{ groups.length - 3 }}</div>
        }
      </div>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOffsetY]="15"
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="tooltipVisible"
      >
        <div class="groups-tooltip">
          <div class="main-groups">
            @for (group of groups; track $index) {
              <div class="group-entity">
                <div
                  class="group-item {{ form }}"
                  [ngStyle]="{
                    background: $safeNavigationMigration(group?.color),
                  }"
                ></div>
                <div class="group-name">{{ group?.name }}</div>
              </div>
            }
          </div>
        </div>
      </ng-template>
    </div>
  `,
  styleUrls: ['./vehicle-group-colors.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VehicleGroupColorsComponent {
  // todo convert it into the custom element
  @Input() groups: CoreGroups[];
  @Input() form: 'circle' | 'square' = 'circle';
  @Input() active: boolean;
  tooltipVisible: boolean;
}
